import { render } from "./BaseSelect.vue?vue&type=template&id=3c8ec0ec&scoped=true"
import script from "./BaseSelect.vue?vue&type=script&lang=js"
export * from "./BaseSelect.vue?vue&type=script&lang=js"

import "./BaseSelect.vue?vue&type=style&index=0&id=3c8ec0ec&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c8ec0ec"]])

export default __exports__